import React, {ReactNode, MouseEvent, ReactElement, isValidElement} from 'react';
import cx from 'classnames';
import {Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import styles from './style.module.scss';
import {createDataTestId} from '../../../utils/dataTestId';
import {ModernTooltip, TooltipProps} from '../Tooltip/ModernTooltip';

type Props = {
    disabled?: boolean;
    active: boolean;
    componentClasses?: string;
    text?: ReactNode;
    id?: string;
    value: string | number;
    icon?: PriorityIcon | ReactElement;
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
    size?: 'medium' | 'large';
    iconClassName?: string;
    wrapClassName?: string;
    tooltipProps?: Partial<TooltipProps>;
};

export const ChatBoxButton = (props: Props) => {
    const {
        active,
        disabled,
        componentClasses,
        text,
        icon,
        onClick,
        value,
        size,
        id,
        iconClassName,
        tooltipProps,
        wrapClassName
    } = props;

    const content = (
        <button
            id={id}
            data-value={value}
            disabled={disabled}
            onClick={onClick}
            className={cx(styles.component, componentClasses, {
                [styles.active]: active,
                [styles.large]: size === 'large',
                [styles.medium]: size === 'medium'
            })}
            {...createDataTestId('action-button', false)}
        >
            <Text skin="breadcrumb" fontWeight="normal" tag="span">
                {!!icon ? (
                    isValidElement(icon) ? (
                        icon
                    ) : (
                        <span className={styles.icon}>
                            <Icon icon={icon as PriorityIcon} componentClasses={iconClassName} />
                        </span>
                    )
                ) : null}
                {text}
            </Text>
        </button>
    );

    return tooltipProps?.tooltip ? (
        <ModernTooltip wrapperClassname={cx(styles.wrap, wrapClassName)} {...props.tooltipProps}>
            {content}
        </ModernTooltip>
    ) : (
        <div className={cx(styles.wrap, wrapClassName)}>{content}</div>
    );
};
